import {
    Button,
    Tableau,
    TableauBody,
    TableauCell,
    TableauHeader,
    TableauHeaderCell,
    TableauRow,
} from '@design-system-etat/dsfr-react';

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { displayStatut } from '../../../../utils/utils';

const TableauRatelier = ({ armes, ouvrirModale }) => {
    const [ordreTri, setOrdreTri] = useState('ASC');
    const [champTri, setChampTri] = useState('statut');

    const donneesTriees = useMemo(() => {
        if (!armes) {
            return [];
        }
        return armes?.sort((a, b) => {
            if (a[champTri] < b[champTri]) return ordreTri === 'ASC' ? -1 : 1;
            if (a[champTri] > b[champTri]) return ordreTri === 'ASC' ? 1 : -1;
            return 0;
        });
    }, [armes, ordreTri, champTri]);

    const entete = [
        { field: 'statut', header: 'Statut' },
        { field: 'numeroEncodage', header: "Numéro d'encodage" },
        { field: 'type', header: 'Type' },
        { field: 'marque', header: 'Marque' },
        { field: 'modele', header: 'Modèle' },
        { field: 'calibreCanon', header: 'Calibre 1' },
        { field: 'classement', header: 'Classement' },
        {
            field: 'regimeDetention',
            header: 'Régime de détention',
        },
    ];

    return (
        <Tableau
            avecBordure
            role="table"
            caption="Ratelier du détenteur - Appuyer sur un entete pour trier la colonne associée"
            noCaption
        >
            <TableauHeader>
                <TableauRow>
                    {entete.map((title) => (
                        <TableauHeaderCell
                            ordreTri={champTri === title.field ? ordreTri : undefined}
                            onClick={() => {
                                if (champTri === title.field) {
                                    setOrdreTri((old) => (old === 'ASC' ? 'DESC' : 'ASC'));
                                } else {
                                    setOrdreTri('ASC');
                                    setChampTri(title.field);
                                }
                            }}
                            scope="col"
                            key={title.field}
                        >
                            {title.header}
                        </TableauHeaderCell>
                    ))}
                </TableauRow>
            </TableauHeader>
            <TableauBody>
                {donneesTriees.map((arme) => {
                    return (
                        <>
                            <TableauRow>
                                <TableauCell>{displayStatut(arme.statut)}</TableauCell>
                                <TableauCell>
                                    <Button
                                        type="button"
                                        variant="tertiary-no-outline"
                                        onClick={() => ouvrirModale(arme)}
                                    >
                                        {arme.numeroEncodage}
                                    </Button>
                                </TableauCell>
                                <TableauCell>{arme.type}</TableauCell>
                                <TableauCell>{arme.marque}</TableauCell>
                                <TableauCell>{arme.modele}</TableauCell>
                                <TableauCell>{arme.calibreCanon}</TableauCell>
                                <TableauCell>{arme.classement}</TableauCell>
                                <TableauCell>{arme.regimeDetention}</TableauCell>
                            </TableauRow>
                        </>
                    );
                })}
            </TableauBody>
        </Tableau>
    );
};

TableauRatelier.propTypes = {
    armes: PropTypes.array.isRequired,
    ouvrirModale: PropTypes.func.isRequired,
};

export default TableauRatelier;
